"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.triggersFor = void 0;
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const lib_event_1 = __importDefault(require("@opsbase/lib-event"));
const Features_1 = __importDefault(require("@opsbase/lib-system/Features/Features"));
const App_1 = __importDefault(require("@opsbase/lib-system/App/App"));
const useSelfActions_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelfActions/useSelfActions"));
function triggersFor(type) {
    const { hasFeature } = (0, useSelfActions_1.default)();
    const hasIoT = hasFeature(Features_1.default[App_1.default.OPSBASE].INTEGRATIONS_IOT.key);
    switch (type) {
        case DataType_1.default.OP:
            return [lib_event_1.default.OP_COMPLETE, lib_event_1.default.OP_MISSED, lib_event_1.default.OP_DUE, lib_event_1.default.OP_LATE];
        case DataType_1.default.ISSUE:
            return [
                lib_event_1.default.ISSUE_CREATED,
                lib_event_1.default.ISSUE_ASSIGNED,
                lib_event_1.default.ISSUE_MISSED,
                lib_event_1.default.ISSUE_STATUS_CHANGED,
                lib_event_1.default.ISSUE_COMMENT,
                lib_event_1.default.ISSUE_CLOSED,
            ];
        case DataType_1.default.ASSET:
            return hasIoT ? [lib_event_1.default.SENSOR_READING, lib_event_1.default.SCHEDULE] : [lib_event_1.default.SCHEDULE];
        default:
            return [];
    }
}
exports.triggersFor = triggersFor;
